import SignInModule from '../../shared-components/SignModule';

/**
 * The sign in page.
 */
function SignInPage() {
	return <SignInModule />;
}

export default SignInPage;